
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/loan",
      function () {
        return require("private-next-pages/[city]/loan/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/loan"])
      });
    }
  